import { OperationsDashboard } from "../components/OperationsDashboard";
import { CustomDashboardProps } from "../utils/types";

export const dashboard: CustomDashboardProps = {
  title: "Operations Dashboard",
  charts: [],
  filters: [],
  Component: OperationsDashboard,
};